import { Minus, Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const NumberStepper = ({ value, onChange, min = 1, max = 99, ariaLabel }) => {
  const { t } = useTranslation()
  const clamp = (v) => Math.min(max, Math.max(min, v))
  const resolvedAria = ariaLabel ?? t('cartesAcces.shared.stepper.quantity')

  return (
    <div className="inline-flex h-[42px] items-center rounded-lg border border-gray-200 bg-white">
      <button
        type="button"
        aria-label={t('cartesAcces.shared.stepper.decrease')}
        disabled={value <= min}
        onClick={() => onChange(clamp(value - 1))}
        className="grid h-full w-10 place-items-center rounded-l-lg text-gray-600 hover:bg-gray-50 disabled:opacity-40"
      >
        <Minus className="h-4 w-4" />
      </button>
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        aria-label={resolvedAria}
        onChange={(e) => onChange(clamp(Number(e.target.value) || min))}
        className="h-full w-12 border-x border-gray-200 text-center text-sm text-gray-900 focus:outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none"
      />
      <button
        type="button"
        aria-label={t('cartesAcces.shared.stepper.increase')}
        disabled={value >= max}
        onClick={() => onChange(clamp(value + 1))}
        className="grid h-full w-10 place-items-center rounded-r-lg text-gray-600 hover:bg-gray-50 disabled:opacity-40"
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  )
}

export default NumberStepper
